<!-- MOLECULE: PageTitle.vue -->
<!-- App-bar title showing either a static app name or a breadcrumb trail. -->

<script setup lang="ts">
//
// Imports
//
import type { BreadcrumbItem } from "~/composables/ui/useAppBar";

//
// Props
//
defineProps<{
  title: string;
  breadcrumbs?: BreadcrumbItem[];
}>();

//
// Composables
//

const { t } = useI18n();
</script>

<template>
  <v-app-bar-title class="ml-2" style="flex: auto; white-space: nowrap; overflow: visible">
    <!-- TEMP: static app name while testing — breadcrumb logic preserved below, just commented out -->
    <span class="text-white font-weight-bold">{{
      t("components.common.navigation-drawer.drawer_header.app_name")
    }}</span>

    <!--
    <template v-if="breadcrumbs && breadcrumbs.length > 1">
      <template v-for="(part, i) in breadcrumbs" :key="i">
        <span v-if="i > 0" class="text-white opacity-50 mx-1">/</span>

        <v-hover v-if="i < breadcrumbs.length - 1 && part.to">
          <template #default="{ isHovering, props: hoverProps }">
            <NuxtLink
              v-bind="hoverProps"
              :to="part.state ? { path: part.to, state: part.state } : part.to"
              :class="[
                'text-white text-decoration-none cursor-pointer transition-opacity',
                isHovering ? 'opacity-100' : 'opacity-80',
              ]"
            >
              {{ part.label }}
            </NuxtLink>
          </template>
        </v-hover>
        <span v-else-if="i < breadcrumbs.length - 1" class="text-white opacity-50">
          {{ part.label }}
        </span>

        <span v-else class="text-white opacity-100">{{ part.label }}</span>
      </template>
    </template>
    <template v-else>
      {{ title }}
    </template>
    -->
  </v-app-bar-title>
</template>
